import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormHtmlGerenciamento from '../../components/forms/FormHtmlGerenciamento'
import Body from '../../components/layouts/body';


class HtmlGerenciamento extends React.Component {
        
    render() {
        return (
            <>            
            <DashboardMenu />
            <Header titulo="Edição de HTML" subtitulo="Cadastro" descricao="" />
            <Body>               
                <FormHtmlGerenciamento />
            </Body>
            </>
        )
    }
}

export default connect()(withRouter(HtmlGerenciamento));